module.exports = __webpack_public_path__ + "media/games-2.f4ff502f.mp4";